var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClipboardCheckgreen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.625 3H5.25C4.14543 3 3.25 3.89543 3.25 5V14.5C3.25 15.6046 4.14543 16.5 5.25 16.5H9.25",
    stroke: "#12CF52",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.875 3H13.25C14.3546 3 15.25 3.89543 15.25 5V11.25",
    stroke: "#12CF52",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.25 4.73077V3.375C6.25 3.16789 6.41789 3 6.625 3C6.83211 3 7.00316 2.83203 7.03864 2.62799C7.14976 1.98878 7.58049 0.75 9.25 0.75C10.9195 0.75 11.3502 1.98878 11.4614 2.62799C11.4968 2.83203 11.6679 3 11.875 3C12.0821 3 12.25 3.16789 12.25 3.375V4.73077C12.25 5.01753 12.0175 5.25 11.7308 5.25H6.76923C6.48247 5.25 6.25 5.01753 6.25 4.73077Z",
    stroke: "#12CF52",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.875 15.375L13.375 16.875L17.125 13.125",
    stroke: "#12CF52",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClipboardCheckgreen);
export default __webpack_public_path__ + "static/media/clipboard-checkgreen.3ea05e16cd470836f41f75b35acca882.svg";
export { ForwardRef as ReactComponent };